import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterContainer = styled.footer`
  background-color: var(--color-backgroundColor);
  padding: 1rem 0;
  color: black;
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  img {
    width: 2rem;
    height: 2rem;
    margin: 0 0.5rem;
    cursor: pointer;
  }

  @media screen and (max-width: 768px) {
    img {
      width: 1.5rem;
      height: 1.5rem;
    }
    padding: 0;
    width: 100%;
  }
`;

export const LogoWrapper = styled.div`
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  @media screen and (max-width: 768px) {
    padding-bottom: 2rem;
    flex-direction: row;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 0;

  @media screen and (max-width: 768px) {
    font-size: 0.8rem;
    font-weight: 600;
    width: 100%;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-left: 1rem;
  @media screen and (max-width: 768px) {
    padding-left: 1rem;
  }

  div {
    display: flex;
    flex-direction: column;
  }
`;

/** Enlace real (mailto, tel, maps) para rastreo y accesibilidad; no usar href="#" ni solo onClick. */
export const FooterCrawlLink = styled.a`
  display: flex;
  align-items: center;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const LeftArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 55%;

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 0;
    flex-direction: column;
    padding: 0;
  }
`;

export const SocialWrapper = styled.div`
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    padding-bottom: 2rem;
  }
`;

export const MiddleArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FooterText = styled.span`
  text-align: start;
`;

export const InternalLinksSection = styled.nav`
  width: 100%;
  max-width: 56rem;
  margin: 0 auto;
  padding: 0.75rem 1rem 0;
`;

export const InternalLinksTitle = styled.h2`
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #4a4a4a;
  margin-bottom: 0.5rem;
  text-align: center;
`;

export const InternalLinksList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.35rem 1rem;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const InternalLink = styled(Link)`
  font-size: 0.8rem;
  color: #2f2e2e;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #b1c2b6;
    text-decoration: underline;
  }
`;

export const LegalLinksContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  width: 100%;
  padding: 1rem 0;
  margin-top: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.5rem 0;
  }
`;

export const LegalLink = styled(Link)`
  font-size: 0.75rem;
  color: #4a4a4a;
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: #b1c2b6;
    text-decoration: underline;
  }

  @media screen and (max-width: 768px) {
    font-size: 0.7rem;
  }
`;
